import api from './api';
import { PaginationLinks, PaginationMeta } from '../components/Modals/Paginator';

declare type GetPlansType = {
  data: any
  meta: PaginationMeta
  links: PaginationLinks
};

export const get = async () => api.get<GetPlansType>('v1/plans');

export const postDesiredSinglePages = async (data: any) => api.post('v1/plans/acquire-pages', data);

export default {
  get,
  postDesiredSinglePages,
};
